import type {
  Collateral, PlaybookRecord, Lead, DemoHub, NudgeAlert,
  AppModule, MappedContact, User, AnData, EngItem, HeatEntry,
  LiveVisitor, RecentVisitor, TrkFeedItem,
} from '../types';

// ══════════════════════════════════════════
//  DEMO ACCOUNTS
// ══════════════════════════════════════════
export const DEMO_ACCOUNTS: User[] = [
  { name: 'Rahul Nair',   title: 'Sales Manager', role: 'admin',   email: 'admin@effybiz.com',   pwd: 'admin123',   color: '#C8973A', ini: 'RN' },
  { name: 'Sneha Kapoor', title: 'Sales Manager', role: 'manager', email: 'manager@effybiz.com', pwd: 'manager123', color: '#6366F1', ini: 'SK' },
  { name: 'Arjun Mehta',  title: 'Sales Rep',     role: 'rep',     email: 'rep@effybiz.com',     pwd: 'rep123',     color: '#22C55E', ini: 'AJ' },
];

// ══════════════════════════════════════════
//  COLLATERALS
// ══════════════════════════════════════════
export const COLLS: Collateral[] = [
  {
    id: 1, name: 'Q2 Product Deck.pptx', type: 'ppt', size: '8.1 MB', pages: 5, tags: ['Pitch', 'Q2'],
    sharedBy: 'Rahul Nair', sharedByIni: 'RN', sharedDate: '14 May 2026',
    recipients: [
      { name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India',  readPct: 100, lastSeen: '2h ago',     views: 4 },
      { name: 'Amit Mehta',   ini: 'AM', org: 'TechCorp Ltd',   readPct: 40,  lastSeen: '3 days ago', views: 1 },
    ],
    pdata: [
      { t: 'Q2 2025 Product Overview',  s: 'Empowering enterprise sales teams',     b: 'This quarter we expand across BFSI and manufacturing verticals with new integrations and a refreshed GTM motion.' },
      { t: 'Feature Highlights',         s: 'What makes us different',              b: 'Our platform saves teams up to 6 hours per week and connects with 200+ tools including Salesforce, HubSpot, and Slack.' },
      { t: 'Customer Success',           s: 'Real results from real teams',         b: 'A leading payments company deployed across 400+ sales reps and reported 3× ROI within 90 days.', stat: true },
      { t: 'Pricing & Packaging',        s: 'Flexible plans for every team',        b: 'Starter ₹999/user · Growth ₹2,499/user · Enterprise Custom' },
      { t: 'Next Steps',                 s: "Let's get started",                    b: 'Book a 30-minute demo. No credit card required.' },
    ],
  },
  {
    id: 2, name: 'Pricing Sheet Q2.xlsx', type: 'pdf', size: '0.3 MB', pages: 3, tags: ['Pricing', 'Q2'],
    sharedBy: 'Rahul Nair', sharedByIni: 'RN', sharedDate: '14 May 2026',
    recipients: [
      { name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India', readPct: 100, lastSeen: '1h ago', views: 3 },
    ],
    pdata: [
      { t: 'Pricing Overview',     s: 'FY 2025–26',                          b: 'All plans billed annually. Monthly billing at 15% premium.' },
      { t: 'Feature Comparison',   s: 'Starter vs Growth vs Enterprise',     b: 'Starter: 10 users. Growth: 100 users. Enterprise: custom.' },
      { t: 'Add-ons',              s: 'Enhance your plan',                   b: 'CRM integration ₹199/mo · White-label ₹299/mo' },
    ],
  },
  {
    id: 3, name: 'Case Study — FinCorp India.pdf', type: 'pdf', size: '1.2 MB', pages: 4, tags: ['Fintech', 'Case Study'],
    sharedBy: 'Sneha Kapoor', sharedByIni: 'SK', sharedDate: '12 May 2026',
    recipients: [
      { name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India', readPct: 75, lastSeen: '5h ago', views: 2 },
      { name: 'Ravi Kumar',   ini: 'RK', org: 'Finserv Co',    readPct: 0,  lastSeen: 'Never',  views: 0 },
    ],
    pdata: [
      { t: 'FinCorp India',    s: '3× ROI in 90 days',        b: 'FinCorp deployed effyBiz across 400+ field sales reps nationwide in Q3 2024.' },
      { t: 'The Challenge',    s: 'Before effyBiz',            b: 'Sales reps spent 3+ hours per week searching for collaterals. Zero visibility into client engagement.' },
      { t: 'The Solution',     s: 'Deployment',                b: 'Centralised library, real-time tracking, co-branded sharing — rolled out in 2 weeks.' },
      { t: 'The Results',      s: 'Measurable impact',         b: '3× ROI · 68% time-to-share reduction · 40% more deal velocity.' },
    ],
  },
  {
    id: 4, name: 'Product Walkthrough.mp4', type: 'video', size: '42.7 MB', pages: 1, tags: ['Video', 'Demo'],
    sharedBy: 'Arjun Mehta', sharedByIni: 'AJ', sharedDate: '9 May 2026',
    recipients: [
      { name: 'Ravi Kumar', ini: 'RK', org: 'Finserv Co', readPct: 0, lastSeen: 'Never', views: 0 },
    ],
    pdata: [{ t: 'Product Demo', s: 'Full platform walkthrough', b: 'Watch our 8-minute walkthrough.' }],
  },
  {
    id: 5, name: 'Brand Guidelines.pdf', type: 'pdf', size: '5.6 MB', pages: 6, tags: ['Brand'],
    sharedBy: 'Rahul Nair', sharedByIni: 'RN', sharedDate: '10 May 2026',
    recipients: [
      { name: 'Amit Mehta', ini: 'AM', org: 'TechCorp Ltd', readPct: 33,  lastSeen: 'Yesterday',  views: 1 },
      { name: 'Neha Gupta', ini: 'NG', org: 'PayScale',     readPct: 100, lastSeen: '3 days ago', views: 2 },
    ],
    pdata: [
      { t: 'Brand Identity', s: 'Visual language',        b: 'Logo, colour, typography, and usage rules.' },
      { t: 'Logo Usage',     s: "Do's and do nots",       b: 'Minimum clear space: 1× logo height.' },
      { t: 'Colour System',  s: 'Primary & secondary',    b: 'Navy #0F1B2D · Gold #C8973A · Surface #F1F4F8' },
      { t: 'Typography',     s: 'DM Sans & DM Serif Display', b: 'Headings: DM Serif Display. Body: DM Sans.' },
      { t: 'Imagery',        s: 'Photography',            b: 'Real people, real environments. Candid over posed.' },
      { t: 'Applications',   s: 'Real-world examples',    b: 'Cards, decks, email signatures — in the template library.' },
    ],
  },
  {
    id: 6, name: 'Live Product Demo', type: 'url', size: 'URL', pages: 1, tags: ['Demo', 'Interactive'],
    url: 'https://demo.effybiz.com',
    demoLogin: { user: 'demo@fincorp.in', pwd: 'FinCorp@2026' },
    demoNote: 'Use the credentials above to explore the full dashboard. Valid for 30 days.',
    sharedBy: 'Rahul Nair', sharedByIni: 'RN', sharedDate: '14 May 2026',
    recipients: [],
    pdata: [{ t: 'Live Product Demo', s: 'Interactive walkthrough', b: 'Explore the full platform at your own pace.' }],
  },
  {
    id: 7, name: 'ROI Calculator', type: 'url', size: 'URL', pages: 1, tags: ['Pricing', 'Tool'],
    url: 'https://roi.effybiz.com',
    demoLogin: null,
    demoNote: 'No login needed — enter your team size and see your projected ROI.',
    sharedBy: 'Rahul Nair', sharedByIni: 'RN', sharedDate: '14 May 2026',
    recipients: [],
    pdata: [{ t: 'ROI Calculator', s: 'See your numbers', b: 'Enter headcount and deal size to get a personalised ROI estimate.' }],
  },
];

// ══════════════════════════════════════════
//  PLAYBOOK RECORDS
// ══════════════════════════════════════════
export const PB_RECORDS: PlaybookRecord[] = [
  {
    name: 'Q2 Product Pitch — Priya Corp', sent: '14 May 2026', status: 'sent', colls: [0, 1, 2],
    recipients: [{ name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India' }], views: 47, opens: 12,
    createdBy: 'Rahul Nair', createdByIni: 'RN',
    dealRoom: { color: '#312E81', accent: '#818CF8', stage: 'Proposal',     stageIco: 'ti-briefcase',      label: 'FinCorp India Q2' },
    security: { otp: true, expiry: '30d', blockFwd: false }, allowShare: true,
    landingPage: {
      heroStyle: 'gradient', heroBg: '#0F1B2D', heroAccent: '#C8973A',
      heroHeadline: "Hi Priya — Here's everything we prepared for FinCorp India",
      heroSubline: 'Handpicked resources for your Q2 review — personalised by Rahul',
      showRepCard: true, repName: 'Rahul Nair', repRole: 'Sales Manager, effyBiz', repAvatar: 'RN',
      repCalendly: 'https://calendly.com/rahul-nair', repWhatsapp: '+91-98765-43210',
      personalMsg: "Hi Priya! I've put together our product deck, pricing sheet, and a FinCorp-specific case study. Let me know if you have any questions before our call.",
      ctaSection: {
        enabled: true,
        items: [
          { id: 'sign',     label: 'Sign Proposal',   icon: 'ti-pencil',    style: 'primary', enabled: true },
          { id: 'meeting',  label: 'Book a Meeting',  icon: 'ti-calendar',  style: 'outline', enabled: true },
          { id: 'message',  label: 'Message Rahul',   icon: 'ti-message-2', style: 'outline', enabled: true },
          { id: 'download', label: 'Download All',    icon: 'ti-download',  style: 'ghost',   enabled: false },
        ],
      },
    },
  },
  {
    name: 'Brand Overview — TechCorp', sent: '10 May 2026', status: 'sent', colls: [0, 4],
    recipients: [{ name: 'Amit Mehta', ini: 'AM', org: 'TechCorp Ltd' }, { name: 'Ravi Kumar', ini: 'RK', org: 'Finserv Co' }],
    views: 31, opens: 7, createdBy: 'Rahul Nair', createdByIni: 'RN',
    dealRoom: { color: '#065F46', accent: '#34D399', stage: 'Negotiation', stageIco: 'ti-handshake',     label: 'TechCorp Brand' },
    security: { otp: false, expiry: '7d', blockFwd: true }, allowShare: false,
    landingPage: {
      heroStyle: 'minimal', heroHeadline: 'Brand Overview for TechCorp', heroSubline: 'Shared by Rahul Nair',
      showRepCard: true, repName: 'Rahul Nair', repRole: 'Sales Manager, effyBiz', repAvatar: 'RN',
      personalMsg: "Hi Amit! Here's the brand overview deck.",
      ctaSection: { enabled: false, items: [] },
    },
  },
  {
    name: 'Enterprise Demo Pack', sent: 'Draft', status: 'draft', colls: [1, 2, 3],
    recipients: [], views: 0, opens: 0, createdBy: 'Rahul Nair', createdByIni: 'RN',
    dealRoom: { color: '#7C2D12', accent: '#FB923C', stage: 'Discovery',   stageIco: 'ti-search',         label: 'Enterprise Demo' },
    security: { otp: false, expiry: null, blockFwd: false }, allowShare: true,
    landingPage: {
      heroStyle: 'gradient', heroHeadline: 'Enterprise Demo Pack', heroSubline: '',
      showRepCard: true, repName: 'Rahul Nair', repRole: 'Sales Manager, effyBiz', repAvatar: 'RN',
      personalMsg: '',
      ctaSection: { enabled: true, items: [{ id: 'meeting', label: 'Book a Meeting', icon: 'ti-calendar', style: 'primary', enabled: true }] },
    },
  },
  {
    name: 'Onboarding Kit — FinCorp', sent: '12 May 2026', status: 'sent', colls: [0, 2],
    recipients: [{ name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India' }], views: 22, opens: 6,
    createdBy: 'Sneha Kapoor', createdByIni: 'SK', assignedToMe: true,
    dealRoom: { color: '#1E3A8A', accent: '#60A5FA', stage: 'Closing',     stageIco: 'ti-target',         label: 'FinCorp Onboarding' },
    security: { otp: true, expiry: '14d', blockFwd: true }, allowShare: false,
    landingPage: {
      heroStyle: 'minimal', heroHeadline: 'Onboarding Kit — FinCorp', heroSubline: '',
      showRepCard: true, repName: 'Sneha Kapoor', repRole: 'Customer Success, effyBiz', repAvatar: 'SK',
      personalMsg: "Welcome to effyBiz, Priya! Here's everything you need to get started.",
      ctaSection: { enabled: false, items: [] },
    },
  },
  {
    name: 'Partner Deck — Q2', sent: '9 May 2026', status: 'sent', colls: [0, 1],
    recipients: [{ name: 'Ravi Kumar', ini: 'RK', org: 'Finserv Co' }], views: 9, opens: 3,
    createdBy: 'Arjun Mehta', createdByIni: 'AJ', assignedToMe: true,
    dealRoom: { color: '#4C1D95', accent: '#C084FC', stage: 'Proposal',    stageIco: 'ti-clipboard-list', label: 'Finserv Partner' },
    security: { otp: false, expiry: null, blockFwd: false }, allowShare: true,
    landingPage: {
      heroStyle: 'gradient', heroHeadline: 'Q2 Partner Deck — Finserv Co', heroSubline: '',
      showRepCard: true, repName: 'Arjun Mehta', repRole: 'Partnerships, effyBiz', repAvatar: 'AJ',
      personalMsg: "Hi Ravi! Here's the Q2 partner deck for your review.",
      ctaSection: {
        enabled: true,
        items: [
          { id: 'meeting', label: 'Book a Call', icon: 'ti-calendar',         style: 'primary', enabled: true },
          { id: 'message', label: 'WhatsApp',    icon: 'ti-brand-whatsapp',   style: 'outline', enabled: true },
        ],
      },
    },
  },
];

// ══════════════════════════════════════════
//  LEADS
// ══════════════════════════════════════════
export const LEADS: Lead[] = [
  {
    id: 'ld1', name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India', email: 'priya@fincorp.com', phone: '+919876543210',
    heat: 'hot', intent: 88, lastSeen: '2h ago', firstSeen: '14 May',
    sourceType: 'playbook', source: 'Playbook · Q2 Product Pitch',
    signals: ['Viewed Pricing Sheet 3×', 'Clicked "Book Demo"', 'Spent 6:14 on page 3', 'Returned same day'],
    sessions: 4, totalTime: '14:32', status: 'new',
  },
  {
    id: 'ld2', name: 'Amit Mehta', ini: 'AM', org: 'TechCorp Ltd', email: 'amit@techcorp.com', phone: '+919876543211',
    heat: 'warm', intent: 54, lastSeen: '5h ago', firstSeen: '12 May',
    sourceType: 'playbook', source: 'Playbook · Brand Overview',
    signals: ['Opened playbook', 'Viewed Brand Overview deck', 'Shared with 1 colleague'],
    sessions: 2, totalTime: '4:32', status: 'contacted',
  },
  {
    id: 'ld3', name: 'Ravi Kumar', ini: 'RK', org: 'Finserv Co', email: 'ravi@finserv.com', phone: '+919876543212',
    heat: 'warm', intent: 41, lastSeen: '1 day ago', firstSeen: '10 May',
    sourceType: 'playbook', source: 'Quick Share · Product Walkthrough',
    signals: ['Viewed video 40%', 'Downloaded pricing'],
    sessions: 1, totalTime: '2:18', status: 'new',
  },
  {
    id: 'ld4', name: 'Neha Gupta', ini: 'NG', org: 'PayScale', email: 'neha@payscale.com', phone: '+919876543213',
    heat: 'cold', intent: 18, lastSeen: '4 days ago', firstSeen: '8 May',
    sourceType: 'manual', source: 'Added manually',
    signals: ['Opened once', 'Spent < 1 min'],
    sessions: 1, totalTime: '0:48', status: 'cold',
  },
  {
    id: 'ld5', name: 'Vikram Singh', ini: 'VS', org: 'AxisBank', email: 'vikram@axis.com', phone: '+919876543214',
    heat: 'hot', intent: 76, lastSeen: '30 min ago', firstSeen: '20 May',
    sourceType: 'landing', source: 'Landing page · Inbound',
    signals: ['Filled enquiry form', 'Viewed pricing twice', 'Booked a meeting'],
    sessions: 3, totalTime: '8:20', status: 'new',
  },
  {
    id: 'ld6', name: 'Sanjay Desai', ini: 'SD', org: 'RetailMax', email: 'sanjay@retailmax.com', phone: '+919876543215',
    heat: 'warm', intent: 62, lastSeen: '3h ago', firstSeen: '22 May',
    sourceType: 'crm', source: 'Salesforce · RetailMax Opportunity',
    signals: ['Synced from Salesforce', 'Deal stage: Proposal', 'Last activity: email open'],
    sessions: 0, totalTime: '—', status: 'new', crmRef: 'SF-00421',
  },
];

// ══════════════════════════════════════════
//  DEMO HUB
// ══════════════════════════════════════════
export const DEMO_HUB: DemoHub = {
  categories: ['Product Tour', 'Sales Demo', 'Onboarding', 'Technical', 'Partner'],
  demos: [
    {
      id: 'demo-001',
      title: 'effyBiz SalesBook — Full Product Tour',
      slug: 'salesbook-product-tour',
      category: 'Product Tour',
      description: 'A complete walkthrough of SalesBook — from collateral management to deal rooms, AI meeting notes, and eSign.',
      thumbnail: null, status: 'live', persona: 'Sales Rep', mode: 'live',
      items: [
        {
          id: 'di-1', type: 'collateral', refId: 'c1', title: 'Q2 Product Deck', openMode: 'iframe', thumbnail: null,
          talkingPoints: [
            'Open with the business problem — ask what their current process looks like',
            'Pause on the ROI slide and ask: what does a 10% improvement mean for your team?',
            'Highlight the integration slide if they mentioned existing tools',
          ],
          pausePrompt: 'Pause here — ask about their current sales process before moving on',
          objections: ['Too expensive → Show ROI calculator on next step', 'Already have a tool → Ask what is missing from it', 'Need team buy-in → Offer a team trial'],
        },
        {
          id: 'di-2', type: 'collateral', refId: 'c2', title: 'Pricing Sheet', openMode: 'iframe', thumbnail: null,
          talkingPoints: [
            'Lead with value, not price — recap what they said mattered most',
            'Starter plan works for 1-3 reps, Growth for teams',
            'Annual pricing saves 20% — mention if budget is a concern',
          ],
          pausePrompt: 'Pause here — let them read the pricing before you explain. Silence is okay.',
          objections: ['Too expensive → Anchor against cost of one lost deal', 'Need approval → Offer to join a call with their manager', 'Want a trial → 14-day free trial is available'],
        },
        {
          id: 'di-3', type: 'app', title: 'Live App Demo', url: 'https://playbook.effybiz.com', login: 'demo@effybiz.com', password: 'Demo@2026', openMode: 'window', thumbnail: null,
          talkingPoints: [
            'Show the playbook creation flow first — it is the fastest wow moment',
            'Let them click around — do not just narrate',
            'Show the analytics dashboard last — it closes the loop on ROI',
          ],
          pausePrompt: 'Hand control to them here — ask them to create a test playbook',
          objections: ['Looks complex → Show how a playbook is created in under 3 minutes', 'Will my team use it? → Show the mobile view'],
        },
      ],
      gate: { enabled: true, fields: ['name', 'email', 'phone', 'company'], autoFill: true },
      share: {},
      createdAt: '2026-05-01', updatedAt: '2026-05-20',
      views: 34, uniqueVisitors: 12, avgTime: '4:32', completionRate: 68,
    },
    {
      id: 'demo-002',
      title: 'FinCorp Onboarding Journey',
      slug: 'fincorp-onboarding',
      category: 'Onboarding',
      description: 'Step-by-step onboarding demo for FinCorp — product intro, case study, and proposal.',
      thumbnail: null, status: 'draft', persona: 'Finance / CFO', mode: 'async',
      items: [
        { id: 'di-4', type: 'collateral', refId: 'c3', title: 'Case Study', openMode: 'iframe', thumbnail: null },
      ],
      gate: { enabled: true, fields: ['name', 'email'], autoFill: true },
      share: {},
      createdAt: '2026-05-10', updatedAt: '2026-05-22',
      views: 0, uniqueVisitors: 0, avgTime: '—', completionRate: 0,
    },
  ],
  sessions: [
    { id: 'ds-1', demoId: 'demo-001', name: 'Priya Sharma', email: 'priya@fincorp.com', phone: '+91 98765 43210', company: 'FinCorp India', source: 'whatsapp', startedAt: '2026-05-18T10:22:00', endedAt: '2026-05-18T10:27:12', steps: [{ stepIdx: 0, durationSec: 142, completed: true }, { stepIdx: 1, durationSec: 88, completed: true }, { stepIdx: 2, durationSec: 42, completed: false }] },
    { id: 'ds-2', demoId: 'demo-001', name: 'Vikram Singh',  email: 'vikram@axisbank.com', phone: '+91 98765 43214', company: 'AxisBank', source: 'email', startedAt: '2026-05-19T14:10:00', endedAt: '2026-05-19T14:15:45', steps: [{ stepIdx: 0, durationSec: 200, completed: true }, { stepIdx: 1, durationSec: 145, completed: true }, { stepIdx: 2, durationSec: 0, completed: false }] },
    { id: 'ds-3', demoId: 'demo-001', name: 'Rahul Nair',    email: 'rahul@company.com',  phone: '+91 99887 76655', company: 'Internal', source: 'direct', startedAt: '2026-05-20T09:00:00', endedAt: '2026-05-20T09:08:30', steps: [{ stepIdx: 0, durationSec: 180, completed: true }, { stepIdx: 1, durationSec: 120, completed: true }, { stepIdx: 2, durationSec: 210, completed: true }] },
  ],
};

// ══════════════════════════════════════════
//  NUDGE ALERTS
// ══════════════════════════════════════════
export const NUDGE_ALERTS: NudgeAlert[] = [
  {
    id: 1, name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India', score: 91, heat: 'hot', trigger: 'pricing3x',
    detail: 'Viewed pricing sheet 3 times in 2 days. Opened Q2 deck 4x total. Last active 2h ago. No reply yet.',
    intent: ['Pricing page: 8:03', 'Product deck: 4:11', 'Return visit: today'],
    suggestion: 'Personalised message referencing their pricing interest',
    template: "Hi Priya, noticed you've been reviewing our pricing a few times — happy to walk through a custom quote for FinCorp's team size. When works best?",
    lastActive: '2 hours ago', sent: false,
  },
  {
    id: 2, name: 'Amit Mehta', ini: 'AM', org: 'TechCorp Ltd', score: 64, heat: 'warm', trigger: 'highTime',
    detail: 'Spent 6+ minutes on the product deck but has gone quiet for 3 days. Engaged with feature comparison section.',
    intent: ['Product deck: 6:12', 'Features page: 3:44', 'No reply: 3 days'],
    suggestion: 'Share a relevant case study to re-engage',
    template: "Hi Amit, thought you'd find this TechCorp case study interesting — very similar to what we discussed. Worth a quick chat?",
    lastActive: '3 days ago', sent: false,
  },
  {
    id: 3, name: 'Ravi Kumar', ini: 'RK', org: 'Finserv Co', score: 38, heat: 'cold', trigger: 'stale2d',
    detail: 'Opened the playbook once but did not go beyond page 2. Has not returned in 5 days.',
    intent: ['Opened once: 5 days ago', 'Page 2 dropoff', 'No return visit'],
    suggestion: 'Re-share with a different hook or new collateral',
    template: "Hi Ravi, wanted to check in on the playbook I shared — can I add anything more relevant to Finserv's current priorities?",
    lastActive: '5 days ago', sent: false,
  },
];

// ══════════════════════════════════════════
//  MODULES
// ══════════════════════════════════════════
export const MODULES: Record<string, AppModule> = {
  library:       { id: 'library',       label: 'Library',         core: true,  enabled: true,  icon: 'ti-files',                  color: '#3B82F6', desc: 'Collateral management and sharing' },
  playbook:      { id: 'playbook',      label: 'Playbook',        core: true,  enabled: true,  icon: 'ti-book-2',                 color: '#8B5CF6', desc: 'Create and share sales playbooks' },
  dealroom:      { id: 'dealroom',      label: 'Deal Room',       core: true,  enabled: true,  icon: 'ti-building',               color: '#7C3AED', desc: 'Collaborative deal workspaces' },
  analytics:     { id: 'analytics',     label: 'Analytics',       core: true,  enabled: true,  icon: 'ti-chart-bar',              color: '#059669', desc: 'Performance metrics and insights' },
  tracking:      { id: 'tracking',      label: 'Live Tracking',   core: true,  enabled: true,  icon: 'ti-broadcast',              color: '#DC2626', desc: 'Real-time engagement monitoring' },
  notifications: { id: 'notifications', label: 'Notifications',   core: true,  enabled: true,  icon: 'ti-bell',                   color: '#F59E0B', desc: 'Activity alerts and updates' },
  meetings:      { id: 'meetings',      label: 'Meetings',        core: true,  enabled: true,  icon: 'ti-calendar-event',         color: '#6366F1', desc: 'Meeting scheduling and notes' },
  esign:         { id: 'esign',         label: 'eSignature',      core: true,  enabled: true,  icon: 'ti-file-certificate',       color: '#22C55E', desc: 'Digital document signing' },
  leads:         { id: 'leads',         label: 'Leads',           core: false, enabled: true,  icon: 'ti-user-bolt',              color: '#EF4444', desc: 'Capture and manage inbound engagement as leads. See who opened what, intent scores, and follow-up actions.' },
  nudges:        { id: 'nudges',        label: 'Smart Nudges',    core: false, enabled: true,  icon: 'ti-bell-ringing',           color: '#F59E0B', desc: 'AI-timed follow-up alerts based on prospect behaviour and engagement signals.' },
  brief:         { id: 'brief',         label: 'Meeting Brief',   core: false, enabled: true,  icon: 'ti-brain',                  color: '#8B5CF6', desc: 'AI-generated meeting prep: opening lines, signals, questions, talking points.' },
  map:           { id: 'map',           label: 'Action Plan',     core: false, enabled: true,  icon: 'ti-checklist',              color: '#3B82F6', desc: 'Mutual action plans (MAP) shared between rep and buyer. Tracks next steps for both sides.' },
  offline:       { id: 'offline',       label: 'Offline Mode',    core: false, enabled: true,  icon: 'ti-wifi-off',               color: '#6B7280', desc: 'Download playbooks for offline use in field demos. Syncs engagement data when back online.' },
  crm:           { id: 'crm',           label: 'CRM',             core: false, enabled: false, icon: 'ti-building-store',         color: '#059669', desc: 'Full pipeline management: contacts, deal stages, revenue reports, activity logging.' },
  demohub:       { id: 'demohub',       label: 'Demo Hub',        core: false, enabled: true,  icon: 'ti-presentation-analytics', color: '#6366F1', desc: 'Create interactive demo journeys with collaterals, app access, and tracking. Share via link, email, or WhatsApp.' },
};

// ══════════════════════════════════════════
//  MAPPED CONTACTS
// ══════════════════════════════════════════
export const MAPPED_CONTACTS: MappedContact[] = [
  { name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India', role: 'Finance Head',     email: 'priya@fincorp.com',    phone: '+919876543210', segment: 'client', mapped: true },
  { name: 'Amit Mehta',   ini: 'AM', org: 'TechCorp Ltd',  role: 'VP Sales',         email: 'amit@techcorp.com',    phone: '+919876543211', segment: 'client', mapped: true },
  { name: 'Ravi Kumar',   ini: 'RK', org: 'Finserv Co',    role: 'Director',         email: 'ravi@finserv.com',     phone: '+919876543212', segment: 'client', mapped: true },
  { name: 'Neha Gupta',   ini: 'NG', org: 'PayScale',      role: 'CTO',              email: 'neha@payscale.com',    phone: '+919876543213', segment: 'client', mapped: true },
  { name: 'Sneha Kapoor', ini: 'SK', org: 'effyBiz',       role: 'Customer Success', email: 'sneha@effybiz.com',    phone: '+919876543214', segment: 'agent',  mapped: true },
  { name: 'Arjun Mehta',  ini: 'AJ', org: 'effyBiz',       role: 'Partnerships',     email: 'arjun@effybiz.com',    phone: '+919876543215', segment: 'rep',    mapped: true },
];

// ══════════════════════════════════════════
//  ANALYTICS DATA
// ══════════════════════════════════════════
export const AN_DATA: AnData = {
  '7d':  { kpi: { views: 3842,  visitors: 641,  links: 38,  conv: 14  }, bars: [{ d: 'Mon', v: 420 }, { d: 'Tue', v: 380 }, { d: 'Wed', v: 290 }, { d: 'Thu', v: 510 }, { d: 'Fri', v: 620 }, { d: 'Sat', v: 710 }, { d: 'Sun', v: 680 }] },
  '30d': { kpi: { views: 14200, visitors: 2310, links: 121, conv: 48  }, bars: [{ d: 'W1', v: 2800 }, { d: 'W2', v: 3600 }, { d: 'W3', v: 4100 }, { d: 'W4', v: 3700 }] },
  'all': { kpi: { views: 38420, visitors: 6210, links: 334, conv: 141 }, bars: [{ d: 'Jan', v: 3100 }, { d: 'Feb', v: 3800 }, { d: 'Mar', v: 4200 }, { d: 'Apr', v: 5100 }, { d: 'May', v: 6400 }] },
};

export const ENG_ALL: EngItem[] = [
  { name: 'Q2 Product Deck.pptx',      type: 'ppt',   pct: 89, views: 1421 },
  { name: 'Case Study — FinCorp.pdf',   type: 'pdf',   pct: 72, views: 980  },
  { name: 'Product Walkthrough.mp4',    type: 'video', pct: 61, views: 760  },
  { name: 'Pricing Sheet Q2.xlsx',      type: 'pdf',   pct: 48, views: 542  },
  { name: 'Brand Guidelines.pdf',       type: 'pdf',   pct: 34, views: 320  },
];

export const HEAT_DATA: HeatEntry[] = [
  { name: 'Q2 Product Deck.pptx',      type: 'ppt', pages: [42, 88, 147, 55, 30] },
  { name: 'Pricing Sheet Q2.xlsx',      type: 'pdf', pages: [18, 34, 60]          },
  { name: 'Case Study — FinCorp.pdf',   type: 'pdf', pages: [55, 72, 38, 91]      },
];

// ══════════════════════════════════════════
//  LIVE TRACKING DATA
// ══════════════════════════════════════════
export const LIVE_VISITORS: LiveVisitor[] = [
  { name: 'Priya Sharma', ini: 'PS', org: 'FinCorp India', playbook: 'Q2 Product Pitch', coll: 'Q2 Product Deck.pptx', page: 3, totalPages: 5, timeOnPage: '2:14', totalTime: '6:04', live: true,  pagesVisited: [1, 2, 3], device: 'Mobile'  },
  { name: 'Amit Mehta',   ini: 'AM', org: 'TechCorp Ltd',  playbook: 'Brand Overview — TechCorp', coll: 'Q2 Product Deck.pptx', page: 1, totalPages: 5, timeOnPage: '0:42', totalTime: '0:42', live: true,  pagesVisited: [1],       device: 'Desktop' },
];

export const RECENT_VISITORS: RecentVisitor[] = [
  { name: 'Ravi Kumar', ini: 'RK', org: 'Finserv Co', playbook: 'Partner Deck — Q2', coll: 'Pricing Sheet Q2.xlsx', page: 3, totalPages: 3, timeOnPage: '—', totalTime: '2:28', live: false, pagesVisited: [1, 2, 3], device: 'Desktop', lastSeen: '18 min ago' },
  { name: 'Neha Gupta', ini: 'NG', org: 'PayScale',   playbook: 'Onboarding Kit',    coll: 'Case Study.pdf',        page: 2, totalPages: 4, timeOnPage: '—', totalTime: '1:12', live: false, pagesVisited: [1, 2],    device: 'Mobile',  lastSeen: '42 min ago' },
];

export const TRK_FEED: TrkFeedItem[] = [
  { dot: '#22C55E', text: '<strong>Priya Sharma</strong> is on page 3 — Customer Success · Q2 Product Deck', time: 'Now'       },
  { dot: '#C8973A', text: '<strong>Amit Mehta</strong> opened Q2 Product Deck for the first time',            time: '42s ago'   },
  { dot: '#E24B4A', text: '<strong>Ravi Kumar</strong> dropped off at page 3',                                time: '18 min ago' },
  { dot: '#378ADD', text: '<strong>Neha Gupta</strong> spent 4 min on page 2',                                time: '42 min ago' },
  { dot: '#22C55E', text: '<strong>Priya Sharma</strong> downloaded Q2 Product Deck',                         time: '1 hr ago'   },
  { dot: '#718096', text: 'New playbook link generated — Enterprise Demo Pack',                                time: '2 hr ago'   },
];

// ══════════════════════════════════════════
//  HOME SCREEN STATIC DATA
// ══════════════════════════════════════════
export const HOME_KPIS = [
  { label: 'Active Deals',      value: '5',    change: '↑ 2 opened today',    changeColor: '#22C55E' },
  { label: 'Buyer Views',       value: '12',   change: '↑ 4 in last hour',    changeColor: '#C8973A' },
  { label: 'Nudges Pending',    value: '3',    change: 'Action needed',        changeColor: '#EF4444', valueColor: '#EF4444' },
  { label: 'Avg Engagement',    value: '68%',  change: '↑ vs last week',      changeColor: '#22C55E' },
];

export const HOME_FEED = [
  { ini: 'PS', bg: 'var(--navy)', color: 'var(--gold)', name: 'Priya Sharma', action: 'visited pricing sheet', org: 'FinCorp India', time: '2 min ago', extra: '3rd visit today', badge: '🔥 HOT — 8 min on pricing', badgeBg: '#FEF2F2', badgeColor: '#EF4444' },
  { ini: 'AM', bg: '#EFF6FF',    color: '#3B82F6',      name: 'Amit Mehta',   action: 'opened product deck',   org: 'TechCorp Ltd',  time: '1h ago',     extra: '6 min read',      badge: '☀️ WARM — gone quiet 3 days', badgeBg: '#FFFBF2', badgeColor: 'var(--gold)' },
  { ini: 'RK', bg: '#F0FFF4',    color: '#276749',      name: 'Ravi Kumar',   action: 'opened playbook',       org: 'Finserv Co',    time: '5 days ago', extra: 'dropped at p.2',  badge: '⚪ COLD — re-engage', badgeBg: 'var(--surface)', badgeColor: 'var(--text3)' },
];

export const HOME_ACTIONS = [
  { color: '#EF4444', title: 'Follow up with Priya — NOW', desc: 'Viewed pricing 3x. 8 min on pricing page. Strike while hot.', nudgeId: 1 },
  { color: '#C8973A', title: 'Re-engage Amit',             desc: '6 min on product deck, quiet 3 days. Share a case study.',   nudgeId: 2 },
  { color: '#718096', title: 'Re-share with Ravi',         desc: 'Dropped at page 2, 5 days ago. Try a new hook.',             nudgeId: 3 },
];

export const HOME_ACTIVE_PLAYBOOKS = [
  { title: 'Q2 Enterprise Pitch',   contact: 'Priya Sharma',  org: 'FinCorp India', engagement: 72, views: 4 },
  { title: 'Product Walkthrough',   contact: 'Amit Mehta',    org: 'TechCorp',      engagement: 45, views: 2 },
  { title: 'Finserv Intro Pack',    contact: 'Ravi Kumar',    org: 'Finserv Co',    engagement: 18, views: 1, danger: true },
];

// ══════════════════════════════════════════
//  SOURCE CONFIG (for Lead cards)
// ══════════════════════════════════════════
export const SOURCE_CONFIG: Record<string, { icon: string; label: string; color: string; bg: string }> = {
  playbook: { icon: 'ti-book-2',          label: 'Playbook',     color: '#6366F1', bg: '#EEF2FF' },
  landing:  { icon: 'ti-world',           label: 'Landing page', color: '#22C55E', bg: '#F0FFF4' },
  crm:      { icon: 'ti-building-store',  label: 'CRM sync',     color: '#0078D4', bg: '#EFF6FF' },
  manual:   { icon: 'ti-user-plus',       label: 'Manual',       color: '#6B7280', bg: '#F9FAFB' },
};

// ══════════════════════════════════════════
//  SIDEBAR NAV CONFIG
// ══════════════════════════════════════════
export const SIDEBAR_NAV = [
  { id: 'home',      label: 'Home',          icon: 'ti-home',                  screen: 'home'      },
  { id: 'admin',     label: 'Library',        icon: 'ti-files',                screen: 'admin'     },
  { id: 'leads',     label: 'Leads',          icon: 'ti-user-bolt',            screen: 'leads',    badge: '6', badgeRed: true },
  { id: 'dealrooms', label: 'Deal Rooms',     icon: 'ti-building',             screen: 'dealrooms' },
  { id: 'demohub',   label: 'Demo Hub',       icon: 'ti-presentation-analytics', screen: 'demohub' },
  { id: 'analytics', label: 'Analytics',      icon: 'ti-chart-bar',            screen: 'analytics' },
  { id: 'tracking',  label: 'Live Tracking',  icon: 'ti-broadcast',            screen: 'tracking', badge: '2' },
  { id: 'client',    label: 'Buyer View',     icon: 'ti-eye',                  screen: 'client'    },
  { id: 'team',      label: 'Team & Modules', icon: 'ti-users',                screen: 'team'      },
];
